export default class GenericResponse {
  public errors?: string;
  public data?: any;

  public get success() {
    if (this.errors) {
      return false;
    }
    return true;
  }

  constructor(data?: any, errors?: string) {
    this.data = data;
    this.errors = errors;
  }
}
